import { initiTracker, Tracker } from "./core";
import Log from "./log";
import { onMonitor } from "./monitor/index";
import { reportPerformance } from "./performance";
import Spm from "./spm/index";
import { helper } from "./utils/helper";
import report from "./utils/report";
Spm.pageMonitor = Spm.loadSpm;
var Tracert = Tracker.Tracert;
var set = Tracker.set;
var logInfo = Log.logInfo;
var logError = Log.logError;
var logJSBridgeError = Log.logJSBridgeError;
var logJsbridgeError = logJSBridgeError;
var reportRPC = Log.reportRPC;
var reportRpc = reportRPC;
var reportFunnel = Log.reportFunnel;
var log = Log;
var spm = Spm;
var pageMonitor = Spm.pageMonitor;
var click = Spm.spmClick;
var expo = Spm.spmExpo;
var spmClick = click;
var spmExpo = expo;
export { Tracker, initiTracker, reportPerformance, onMonitor, report, helper,
/**
 * @deprecated 下一个大版本移除
 */
Tracert, set,
/**
 * @deprecated 下一个大版本移除
 */
log,
/**
 * @deprecated 下一个大版本移除
 */
spm, pageMonitor, click, expo,
/**
 * @deprecated 下一个大版本移除
 */
spmClick,
/**
 * @deprecated 下一个大版本移除
 */
spmExpo, logInfo, logError, reportFunnel,
/**
 * @deprecated 下一个大版本移除
 */
logJsbridgeError, logJSBridgeError,
/**
 * @deprecated 下一个大版本移除
 */
reportRpc, reportRPC };
export default {
  Tracker: Tracker,
  initiTracker: initiTracker,
  reportPerformance: reportPerformance,
  onMonitor: onMonitor,
  report: report,
  helper: helper,
  /**
   * @deprecated 下一个大版本移除
   */
  Tracert: Tracert,
  set: set,
  /**
   * @deprecated 下一个大版本移除
   */
  log: log,
  /**
   * @deprecated 下一个大版本移除
   */
  spm: spm,
  pageMonitor: pageMonitor,
  click: click,
  expo: expo,
  /**
   * @deprecated 下一个大版本移除
   */
  spmClick: spmClick,
  /**
   * @deprecated 下一个大版本移除
   */
  spmExpo: spmExpo,
  logInfo: logInfo,
  logError: logError,
  reportFunnel: reportFunnel,
  /**
   * @deprecated 下一个大版本移除
   */
  logJsbridgeError: logJsbridgeError,
  logJSBridgeError: logJSBridgeError,
  /**
   * @deprecated 下一个大版本移除
   */
  reportRpc: reportRpc,
  reportRPC: reportRPC
};